<template>
  <div class="">
    <div class="relative">
      <img
        src="@/assets/images/line/Vector 9.png"
        alt="lineimg"
        class="m-auto px-4"
      />
      <div class="absolute bg-design-mbr-dots mob-hidden">
        <img
          src="../../../assets/images/caregiver/mbr-dots.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <!-- <div class="absolute h-full lg:hidden md:hidden block -mt-40px">
        <img
          src="../../../assets/images/line/hcp-line-2.svg"
          alt="bg"
          class="object-cover"
        />
      </div> -->
      <div class="flex justify-center md:py-0 lg:py-0 py-0 mt-0">
        <div
          class="borderprimary md:p-4 lg:p-4 absolute lg:top-32 md:top-32 top-0 rounded-2xl z-10"
        >
          <div class="bgcceff2 rounded-2xl">
            <div class="md:flex lg:flex items-center lg:p-6 md:p-6 p-4">
              <p class="font-semibold text-black fsize20 sm-fsize14">
                Share your story with us
              </p>
              <div
                class="md:pl-14 lg:pl-14 md:pt-0 lg:pt-0 pt-4 items-center flex lg:mx-auto md:mx-auto mob-justify-center"
              >
                <!-- <a
                  target="_blank"
                  href="https://caregiversaathi.co.in/share-your-story.html"
                  class="acharhover-s"
                > -->
                <base-button
                  @click="
                    handleRoute('request-form', 'share-your-story-expertise')
                  "
                  type="primary"
                  class="py-2 px-8 text-base font-bold border-2 md:w-auto lg:w-auto w-full fsize16-14"
                  >Share
                </base-button>

                <!-- </a> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="md:my-0 lg:my-0 md:relative lg:relative">
      <div class="absolute bottom-16 right-0 mob-hidden">
        <img
          src="../../../assets/images/bg-des/hcp-partners-bgt.svg"
          alt="bg-polygon"
          class=""
        />
      </div>
      <div
        class="w-full bgcceff2-res md:py-12 lg:py-12 md:px-12 lg:px-28 flex-wrap flex flexcolreverse"
      >
        <div
          class="md:w-1/2 lg:w-1/2 w-full px-6 md:pt-0 lg:pt-0 pt-8 z-10 res-bg-white"
        >
          <div class="w-full">
            <!--   <div class="flex w-full py-6 items-center">
             <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/ta.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-2/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/tc.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/e2.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/cl.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/BI.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div> -->
            <img
              src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/CG/HealthCare-page/Collaboration%20with%20Healthcare%20system%20.jpg"
              class="custborderradius"
            />
          </div>
          <div class="w-full mob-hidden">
            <!--
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/ta.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-2/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/tc.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            <div class="flex w-full py-6 items-center">
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/e2.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/cl.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
              <div class="w-1/3 md:mx-0 lg:mx-0 mx-2">
                <img
                  src="../../../assets/images/BI.png"
                  alt="Partners"
                  class="prt-img-ht"
                />
              </div>
            </div>
            -->
          </div>
        </div>

        <div class="md:w-1/2 lg:w-1/2 w-full px-4 m-auto">
          <div class="relative lg:mt-0 md:mt-0">
            <p class="title sm-fsize16 md:font-normal lg:font-normal font-bold">
              Collaboration With Healthcare Services
            </p>
            <p
              class="subtitle lg:pt-10 md:pt-10 pt-2 lh32px sm-fsize13 sm-lh28"
            >
              Our partnership model with healthcare organisations, institutes,
              and clinics aims to deliver effective care for patients and their
              families. The intent is to combine efforts to empower family
              caregivers while enabling our healthcare systems to function
              efficiently through active learning and engagement.
            </p>
            <!-- <p class="subtitle pt-8 lh32px font-normal letter-spacing-2px">
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui
              officia deserunt mollit anim id est laborum. Excepteur sint
              occaecat cupidatat non proident, sunt in culpa qui officia
              deserunt mollit anim id est laborum.
            </p> -->
          </div>
          <div class="md:pt-10 lg:pt-10 pt-6">
            <!-- <a
              class="hover:text-white"
              target="_blank
              "
              href="https://forms.office.com/r/gie1XhrhDa"
            > -->
            <base-button
              outline
              @click="handleRoute('request-form', 'partner-with-us')"
              type="primary"
              class="md:px-10 lg:px-10 px-6 md:py-3 lg:py-3 py-1 fs16700 border-2 fsize16-14"
              >Partner with us</base-button
            >
            <!-- </a> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
    handleClickRedirection(name) {
      this.$router.push({ name: name });
    },
    handleRoute(name, route) {
      this.$router.push({
        name: name,
        params: {
          pathName: route,
        },
      });
    },
  },
};
</script>
